import { setTemplates, setLoading, setError } from "../slices/smsTemplate";
import { smsSent, smsScheduled } from "../slices/message";
import { getScheduledMessages } from "./messageActions";
import axios from "axios";

export const getTemplates = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.get("/api/sms/templates");
    //console.log("SMS Templates Data: ", data);
    const { smsTemplates } = data;
    // Sort by SAVEDSMSMESS_NAME before dispatch
    const sortedTemplates = smsTemplates.slice().sort((a, b) => {
      if (a.SAVEDSMSMESS_NAME < b.SAVEDSMSMESS_NAME) return -1;
      if (a.SAVEDSMSMESS_NAME > b.SAVEDSMSMESS_NAME) return 1;
      return 0;
    });
    dispatch(setTemplates(sortedTemplates));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading templates. Please try again later"
      )
    );
  }
};

export const sendSMSAction = (smsData) => async (dispatch) => {
  //dispatch(setLoading());
  try {
    switch (smsData.delayOption) {
      case "0":
      case "1": {
        const { data } = await axios.post("/api/sms/send", smsData);
        dispatch(smsSent({ recipient: smsData.to, message: smsData.body, jobNumber: smsData.jobNumber }));
        return data;
      }
      case "2":
      case "3": {
        const { data } = await axios.post("/api/sms/send-scheduled", smsData);
        dispatch(
          smsScheduled({
            recipient: smsData.to,
            message: smsData.body,
            jobNumber: smsData.jobNumber,
            scheduledFor: smsData.scheduledFor,
          })
        );
        dispatch(getScheduledMessages());
        return data;
      }
      default: {
        break;
      }
    }
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred sending SMS. Please try again later"
      )
    );
  }
};
